import React, { FunctionComponent } from "react"

interface LoungeSVGProps {}

const LoungeSVG: FunctionComponent<LoungeSVGProps> = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="2" y="1.00005" width="20" height="8" rx="4" fill="#6633FF" />
      <rect x="13" y="12" width="9" height="9" rx="3.2" fill="#6633FF" />
      <path
        d="M3 13L5.91632 20.0478L6.95168 16.9787L10 15.9363L3 13Z"
        fill="#6633FF"
        stroke="#6633FF"
        stroke-width="2.4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export default LoungeSVG
